import { PayloadAction } from '@reduxjs/toolkit';
import { IState } from '../types/state';

const setScrollToSelectedEventId = (
  state: IState,
  action: PayloadAction<{ id: string }>,
) => {
  state.specialEvents.scrollToSelectedEvent = action.payload.id;
};

export default setScrollToSelectedEventId;
